import { createContext, useContext, type ReactNode } from 'react';
import type { EcoBoxServices } from '@ecobox/firebase';
import { useStore } from '@ecobox/ui';

const ServicesContext = createContext<EcoBoxServices | null>(null);

export function ServicesProvider({
  services,
  children,
}: {
  services: EcoBoxServices;
  children: ReactNode;
}) {
  return <ServicesContext.Provider value={services}>{children}</ServicesContext.Provider>;
}

export function useServices(): EcoBoxServices {
  const services = useContext(ServicesContext);
  if (!services) throw new Error('ServicesProvider is missing.');
  return services;
}

export const useSession = () => useStore(useServices().session);
export const useSyncState = () => useStore(useServices().sync);
export const useLedger = () => useStore(useServices().writer);
export const useBranch = () => useStore(useServices().branch);
export const useEchoes = () => useStore(useServices().echoes);
